// extracted by mini-css-extract-plugin
module.exports = {"nav_pagination":"pagination_nav_pagination__3W5wF","button_pagination":"pagination_button_pagination__11X-v","noButton":"pagination_noButton__8_bAV"};